import React, { useEffect } from "react";
import LanguageToggle from "./LanguageToggle";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Menu, X } from "lucide-react";
import { setSideBarOpen } from "store/slices/commonSlice";

const AdminHeader = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { authUserDetails } = useSelector((state) => state.Auth);
  const { isSideBarOpen } = useSelector((state) => state.CommonActions);
  const { name } = authUserDetails || {};
  useEffect(() => {
  }, [isSideBarOpen]);
  return (
    <header id="page-topbar">
      <div className="g_between">
        <div className={`d-flex gap-3 align-items-center header_item ${!isSideBarOpen ? "sidebar-collapsed" : ""}`}>
          <button
            type="button"
            className="border-0"
            onClick={() => dispatch(setSideBarOpen(!isSideBarOpen))}
          >
            <Menu size={24} />
          </button>

          <h6 className="title">
            {t("Hello")} {name}
          </h6>
          {/* <LanguageToggle /> */}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
